import { DOCUMENT } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, Inject } from '@angular/core';
let ScriptsService = /*#__PURE__*/(() => {
  class ScriptsService {
    constructor(document) {
      this.document = document;
    }
    /**
     * Creates a <script> element, configures it and adds it to the <head> element.
     *
     * @param {string} src The source of the script being added.
     * @param {string} innerHtml contents of script to be run in the head.
     * @param {boolean} async Does the script tag have async keyword.
     * @param {boolean} onload callback function after script has loaded
     */
    addScriptElement(src, innerHtml, async, onload) {
      const script = this.getDocument().createElement('script');
      if (src) {
        script.src = src;
      }
      if (innerHtml) {
        script.innerHTML = innerHtml;
      }
      if (async) {
        script.async = async;
      }
      if (onload) {
        script.onload = onload;
      }
      this.getDocument().head.appendChild(script);
    }
    /**
     * Creates a <link> element, configures it and adds it to the <head> element.
     *
     * @param {string} href The link of the script being added.
     * @param {string} rel The link type
     */
    addLinkElement(href, rel) {
      const link = this.document.createElement('link');
      link.href = href;
      link.rel = rel || 'stylesheet';
      this.getDocument().head.appendChild(link);
    }
    /** Helper function that returns the document. Used to mock document in Unit Tests */
    getDocument() {
      return this.document;
    }
  }
  ScriptsService.ɵfac = function ScriptsService_Factory(t) {
    return new (t || ScriptsService)(i0.ɵɵinject(DOCUMENT));
  };
  ScriptsService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ScriptsService,
    factory: ScriptsService.ɵfac,
    providedIn: 'root'
  });
  return ScriptsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { ScriptsService };
